import { Injectable, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountService } from 'app/core/auth/account.service';
import { StateStorageService } from './state-storage.service';

@Injectable({ providedIn: 'root' })
export class UserRouteAccessService {
	constructor(
		private router: Router,
		private accountService: AccountService,
		private stateStorageService: StateStorageService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.accountService.identity().pipe(
			map((account) => {
				if (account) {
					const authorities = route.data['authorities'];

					if (
						!authorities ||
						authorities.length === 0 ||
						this.accountService.hasAnyAuthority(authorities)
					) {
						return true;
					}

					if (isDevMode()) {
						console.error('User has not any of required authorities: ', authorities);
					}
					this.router.navigate(['access-denied'], { queryParams: { path: state.url } });
					return false;
				}

				this.stateStorageService.storeUrl(state.url);
				this.router.navigate(['/sign-in']);
				return false;
			})
		);
	}
}
